import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { AvatarModule } from 'src/app/components/avatar/avatar.module.js';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AdminAiTesterRoutingModule } from './admin-ai-tester-routing.module.js';
import { AdminAiTesterComponent } from './admin-ai-tester.component.js';
import { AgentComparisonTesterComponent } from './agent-comparison-tester/agent-comparison-tester.component.js';
import { SingleAgentTesterComponent } from './single-agent-tester/single-agent-tester.component.js';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedPipesModule,
    AvatarModule,
    AdminAiTesterRoutingModule,
    NgxTippyModule,
  ],
  declarations: [AdminAiTesterComponent, SingleAgentTesterComponent, AgentComparisonTesterComponent],
  exports: [AdminAiTesterComponent],
})
export class AdminAiTesterModule {}
